import banner0 from './banner-0.png'
import btn from './btn.png'
import banner1 from './banner1.png'
import jLogo from './j-logo.png'
import msgBg0 from './msg-bg-0.png'
import msgImage0 from './msg-image-0.png'
import msgImage1 from './msg-image-1.png'
import msgImage2 from './msg-image-2.png'
import msgImage3 from './msg-image-3.png'
import msgImageFlex1 from './msg-image-flex-1.png'
import msgImageFlex2 from './msg-image-flex-2.png'
import msgImageFlex3 from './msg-image-flex-3.png'
import priceForm from './price-form.png'
let msgImageFlexList = [
  {
    url: msgImageFlex1,
    msg: 'リビングでTVBOXで4K画質で人気動画を観る'
  },
  {
    url: msgImageFlex2,
    msg: 'FireTV Stickで夫婦仲良くNETFLIXを観る'
  },
  {
    url: msgImageFlex3,
    msg: '子供部屋でタブレットでABEMAのアニメを観る'
  }
]
export {
  banner0 as banner0,
  btn as btn,
  banner1 as banner1,
  jLogo as jLogo,
  msgBg0 as msgBg0,
  msgImage0 as msgImage0,
  msgImage1 as msgImage1,
  msgImage2 as msgImage2,
  msgImage3 as msgImage3,
  msgImageFlexList as msgImageFlexList,
  priceForm as priceForm
}


// WEBPACK FOOTER //
// ./src/images/vpn/index.js